export type QueuePriority = 0 | 2;
interface IPriorityTypeEnum {
    Front: QueuePriority;
    Back: QueuePriority;
    getName(): string;
    format(value: number): string | undefined;
}

const datasource = () => [
    { id: 2, name: 'Eilės pradžią', code: null, type: null, group: null },
    { id: 0, name: 'Eilės pabaigą', code: null, type: null, group: null }
];

export const queuePriority: IPriorityTypeEnum = {
    Front: 2,
    Back: 0,
    getName() {
        return 'priorityType';
    },
    format(value: number) {
        const item = datasource().find(x => x.id === value);
        return item && item.name;
    }
};
